import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

import { ManageCampaignService } from 'src/app/private/services/manage-campaign.service';
import { UsersService } from 'src/app/private/services/users.service';
import { WhatsappTemplateService } from 'src/app/private/services/whatsapp-tempate.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { TrackingService } from 'src/app/private/services/tracking.service';
import { ClientService } from 'src/app/private/services/client.service';
import { Router } from '@angular/router';
import { CampaignService } from 'src/app/private/services/campaign.service';
import { WhatsappVoiceCampaignService } from 'src/app/private/services/whatsapp-voice-campaign.service';
import { CampaignSegmentService } from 'src/app/private/services/campaign-segment.service';
import { WhatsappVoiceCampaignComponent } from '../whatsapp-voice-campaign/whatsapp-voice-campaign.component';
import { filterContactGroupsByCampaignType } from 'src/app/utils/contact-group-type.util';
import { ContactGrouopService } from 'src/app/private/services/contact-groups.service';

@Component({
  selector: 'app-broadcast-campaign',
  templateUrl: './broadcast-campaign.component.html',
  styleUrls: ['./broadcast-campaign.component.scss']
})
export class BroadcastCampaignComponent {

  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  totalRows = 0;
  currentPage = 0;
  pageSize = 25;
  pageSizeOptions: number[] = [10, 25, 100];
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  searchQuery = new FormControl();
  dateQuery = new FormControl();
  btnLoading = false;
  initialLoad = true;
  reloading = false;
  emailTemplates: any[] = [];
  whatsappConfigs:any = "";
  emailConfig:any = "";
  whatsappTemplates: any[] = [];
  contactGroups: any[] = [];
  allContactGroups: any[] = [];

  isFetchingTemplates = false;
  whatsappPreviewTemplate: any;
  processedData: any;
  attachments: any[] = [];
  isAdmin: boolean = false;
  filterArray:any = []
  active = "whatsapp"
organisationEmails : string[] = [];
  testEmail: string = '';
  testEmailLoading: boolean = false;
  testPhone: string = '';
  testPhoneLoading: boolean = false;
  launchState: 'idle' | 'launching' | 'success' | 'failed' = 'idle';
  launchErrorMessage: string = '';
  totalContactsInGroup: number | null = null;
  skipCampaignCount: number | null = null;
  isLoadingAudienceCount = false;

  // Email Reputation
  reputationData: any = null;
  isReputationLoading: boolean = false;
  reputationError: string | null = null;
  campaign: any = {
    "id": "",
    "campaign_name": "",
    "contact_group_id": "",
    "campaign_source": "",
    "campaign_date": "",
    "subject": "",
    "template_id": "",
    "is_schedule": false,
    "status": "pending",
    "hospital_id": "",
    "center_id": "",
  }

  displayedColumns: string[] = ["campaign_name", "campaign_group", "campaign_date",

    "is_schedule",
    "schedule_date",
    "schedule_time",
    "status", "action"];

  
    defaultFilter = [
      "campaign_name",
      "status",
      "segment",
    ]

  @ViewChild('connectSetting') connectSetting!: TemplateRef<any>;
  @ViewChild(WhatsappVoiceCampaignComponent) whatsappVoiceCampaignComponent!: WhatsappVoiceCampaignComponent;

  constructor(
    private toast: ToastrService,
    private api: ManageCampaignService,
    private modalService: NgbModal,
    private localStorage: LocalStorageService,
    private sanitizer: DomSanitizer,
    private tracker: TrackingService,
    private ClientService:ClientService,
    private router:Router,
    private campaignService: CampaignService,
    private voiceCampaignService: WhatsappVoiceCampaignService,
    private campaignSegmentService: CampaignSegmentService,
    private contactGroupService: ContactGrouopService
  ) {
     this.isAdmin = this.localStorage.checkFullAccessForTableList(
      this.localStorage.getRole()
    );
  }

  ngAfterViewInit() {
    this.fetchCampaigns();
    this.fetchContactGroups();
    this.fetchEmailTemplates();
    this.fetchWhatsAppTemplates();
    this.loadOrganisationEmails();

    // Re-fetch when search or date filter changes (reset to page 1)
    this.searchQuery.valueChanges.subscribe(() => this.fetchCampaigns(true));
    this.dateQuery.valueChanges.subscribe(() => this.fetchCampaigns(true));

    this.filterArray.push(
      { key: 'campaign_name', value: 'Campaign Name', type: 'text' },
      { key: 'status', value: 'Status', type: 'select', options: [
        'Pending',
        'Scheduled',
        'Completed',
        'Failed',
      ] },
      { key: 'segment', value: 'Segment', type: 'select', options: [] }
    );
    this.loadCampaignSegments();
  }

  loadCampaignSegments() {
    this.campaignSegmentService.getAllCampaignSegmentTypes({
      client_id: this.localStorage.getClientId()
    }).subscribe({
      next: (res: any) => {
        const segments = Array.isArray(res?.data) ? res.data : [];
        const segmentFilter = this.filterArray.find((item: any) => item.key === 'segment');
        if (segmentFilter) {
          segmentFilter.options = segments.map((segment: any) => segment.segment_name).filter(Boolean);
        }
      },
      error: () => {
        const segmentFilter = this.filterArray.find((item: any) => item.key === 'segment');
        if (segmentFilter) {
          segmentFilter.options = [];
        }
      }
    });
  }
  
 analytics(analyticsContent: TemplateRef<any> | null, element: any) {
  this.router.navigate(['main/email-campaign-anlaytics/'+element.id]);
  }
  
  whatsappAnalytics(element: any) {
    this.router.navigate(['main/whatsapp-campaign-analytics/'+element.id]);
  }

  

  fetchEmailTemplates() {

    const data : any = {
      "client_id": this.localStorage.getClientId(),
    }

    if(!this.isAdmin) {
      data['user_id'] = this.localStorage.getUserId();
    }

    this.api.getAllEmailTemplates(data).subscribe((res: any) => {
      this.emailTemplates = this.sortByCreatedAtDesc(res);
    }
    );
  }

  sortByCreatedAtDesc(data: any[]) {
  return [...data].sort((a, b) => {
    const dateA = a.createdAt ? new Date(a.createdAt).getTime() : 0;
    const dateB = b.createdAt ? new Date(b.createdAt).getTime() : 0;

    return dateB - dateA; // DESC
  });
}
  fetchWhatsAppTemplates() {

    const param:any= {
      "client_id": this.localStorage.getClientId(),
      "status": "APPROVED"
    }

    if(!this.isAdmin) {
      param['user_id'] = this.localStorage.getUserId();
    }

    this.api.getAllTemplatesWithStatusFilter(param).subscribe((res: any) => {

      this.whatsappTemplates = this.sortByCreatedAtDesc(res);;
    }
    );
  }
  dateFilter(event: any) {
    console.log('Date Filter Event:', event);
    this.dateQuery.setValue(event);
  }

  fetchContactGroups() {
    const payload : any = {
      "where": {
        "client_id": this.localStorage.getClientId(),
      },
      "order": {
        "col": "\"contact_group\".\"updatedAt\"",
        "dir": "DESC"
      }
    }

    if(!this.isAdmin) {
      payload.where.user_id = this.localStorage.getUserId();
    }

    this.api.getAllContactGroups(payload).subscribe((res: any) => {
      const groups = Array.isArray(res) ? res : (res?.rows ?? []);
      this.allContactGroups = this.sortByCreatedAtDesc(groups);
      this.contactGroups = filterContactGroupsByCampaignType(
        this.allContactGroups,
        this.active as 'email' | 'whatsapp' | 'call'
      );
    }
    );
  }


  loadOrganisationEmails() {

  // this.organisationEmails = ['sales@domain.com','support@domain.com'];
 

   let payload: any = {

              where: {
                client_id: this.localStorage.getClientId()
              },
              order: {
                col: "",
                dir: ""
              }
            };

 this.ClientService.getAllClientConfig(payload).subscribe({
  next: (res: any) => {


    const selectedEmailConfig = this.getActiveEmailConfig(res);
    const selectedWhatsappConfig = this.getActiveWhatsappConfig(res);
    console.log('Selected WhatsappConfig config:', selectedWhatsappConfig);
    if (Array.isArray(selectedEmailConfig)) {
      const activeEmail = selectedEmailConfig.find(
        (config: any) => config?.is_active === true
      );

      if (activeEmail) {
       // console.log('Active email config found:', activeEmail);
        this.organisationEmails = activeEmail.settings.organisation_email|| [];
      
      } else {
        this.organisationEmails = [];
      }
    } else {
      console.warn('selectedEmailConfig is not an array:', selectedEmailConfig);
      this.organisationEmails = [];
    }
  },
  error: (err) => {

    console.error('Failed to load organisation emails', err);
    this.organisationEmails = [];
  }
});
}


getActiveEmailConfig(response: any): any | null {
  if (
    !response ||
    !response.rows ||
    !response.rows.length ||
    !response.rows[0].email_config
  ) {
    return null;
  }

  this.emailConfig = response.rows[0].email_config;
  return this.emailConfig;
}

getActiveWhatsappConfig(response: any): any | null {
  if (
    !response ||
    !response.rows ||
    !response.rows.length ||
    !response.rows[0].whats_app_config
  ) {
    return null;
  }

  this.whatsappConfigs = response.rows[0].whats_app_config || null;
  return this.whatsappConfigs;
}

  /** Single imperative fetch — called from ngAfterViewInit, (page) events, tab change, search/date changes */
  fetchCampaigns(resetPage = false) {
    if (this.active === 'call' || this.active === 'flow') {
      this.initialLoad = false;
      this.reloading = false;
      return;
    }
    try {
      if (resetPage) {
        this.currentPage = 0;
      }

      this.reloading = true;

      let payload: any = {
        where: {
          client_id: this.localStorage.getClientId(),
          campaign_type: this.active,
        },
        page: this.currentPage * this.pageSize,
        limit: this.pageSize,
        order: {
          col: '"campaign"."createdAt"',
          dir: 'DESC',
        },
      };

      if (this.searchQuery.value) {
        for (let [key, value] of Object.entries(this.searchQuery.value)) {
          if (this.defaultFilter.includes(key) && value !== '' && value != null) {
            payload.where = { ...payload.where, [key]: value };
          }
        }
      }

      if (this.dateQuery.value) {
        payload = { ...payload, ...this.dateQuery.value };
      }

      if (!this.isAdmin) {
        payload.where = { ...payload.where, user_id: this.localStorage.getUserId() };
      }

      this.api.getAllManangeCampaign(payload).subscribe({
        next: (response: any) => {
          this.initialLoad = false;
          this.reloading = false;
          this.btnLoading = false;
          this.totalRows = response?.count ?? 0;
          this.dataSource = new MatTableDataSource<any>(response?.rows ?? []);
        },
        error: (e: any) => {
          this.btnLoading = false;
          this.initialLoad = false;
          this.reloading = false;
          console.error(e);
        },
      });
    } catch (e) {
      this.reloading = false;
      console.error(e);
    }
  }

  /** Called from paginator (page) event on both tabs */
  onPageChange(event: any) {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.fetchCampaigns();
  }

  /** Kept for compatibility – just delegates to fetchCampaigns */
  loadData(type?: string) {
    this.fetchCampaigns();
  }

  reload(type?: string) {
    this.fetchCampaigns();
  }

  handleUpdateData(type?: string) {
    if (type === 'create') {
      this.toast.success('Campaign created successfully');
    } else if (type === 'update') {
      this.toast.success('Campaign updated successfully');
    } else if (type === 'delete') {
      this.toast.success('Campaign deleted successfully');
    }
    this.btnLoading = false;
    this.modalService.dismissAll();
    this.fetchCampaigns();
  }

  searchFilter(query: any) {
    console.log('Search Query:', query);
    this.searchQuery.setValue(query);
    // fetchCampaigns(true) is triggered by the valueChanges subscription in ngAfterViewInit
  }


  open(content: any) {
    // Check if WhatsApp configuration exists and is valid
    const isWhatsAppConfigured = this.whatsappConfigs && 
                                  (Array.isArray(this.whatsappConfigs) ? this.whatsappConfigs.length > 0 : true);
    
    // Check if campaign email is configured
    const isCampaignEmailConfigured = this.organisationEmails.filter((item: any) => item.type == 'campaign');
    
    console.log("WhatsApp Config:", this.whatsappConfigs);
    console.log("Is WhatsApp Configured:", isWhatsAppConfigured);
    console.log("Campaign Email Configured:", isCampaignEmailConfigured);
    
    // If WhatsApp campaign but WhatsApp is not configured
    if (this.active === 'whatsapp' && !isWhatsAppConfigured) {
      this.modalService.open(this.connectSetting, { size: 'lg', scrollable: true, centered: true });
      return;
    }
    
    // If email campaign but campaign email is not configured
    if (this.active === 'email' && isCampaignEmailConfigured.length === 0) {
      this.modalService.open(this.connectSetting, { size: 'lg', scrollable: true, centered: true });
      return;
    }
    
    // If call campaign, use its own component to handle creation
    if (this.active === 'call' && this.whatsappVoiceCampaignComponent) {
      this.whatsappVoiceCampaignComponent.openCreate();
      return;
    }

    // All checks passed, open the create campaign modal
    this.modalService.open(content, { size: 'lg', scrollable: true, centered: true });
  }

  changeTab(type: any) {
    this.active = type;
    this.initialLoad = true;
    this.currentPage = 0;  // reset to first page on tab switch
    this.dataSource = new MatTableDataSource<any>([]);
    this.fetchCampaigns();
    this.fetchContactGroups();
    this.campaign = {
      'id': '',
      'campaign_name': '',
      'contact_group_id': '',
      'campaign_source': '',
      'campaign_date': '',
      'subject': '',
      'template_id': '',
      'is_schedule': false,
      'status': 'pending',
      'hospital_id': '',
      'center_id': '',
    };
  }

  formType: 'Edit' | 'View' = 'Edit';
  cloningId: any = null;

  edit(content: any, event: any) {
    this.formType = 'Edit';
    this.campaign = this.withContactGroup(event);
    this.modalService
      .open(content, { size: 'lg', scrollable: true, centered: true });
  }

  contactGroupLabel(element: any): string {
    return this.withContactGroup(element)?.contact_group?.name || '—';
  }

  private withContactGroup(element: any): any {
    if (!element) return element;
    const saved = element.contact_group?.name || element.contact_group_name;
    if (saved) {
      element.contact_group = { ...(element.contact_group || {}), name: saved };
      return element;
    }
    const match = (this.allContactGroups || []).find((group: any) =>
      String(group.id) === String(element.contact_group_id)
    );
    if (match) {
      element.contact_group = { id: match.id, name: match.name };
    }
    return element;
  }

  viewCampaign(content: any, event: any) {
    this.formType = 'View';
    this.campaign = this.withContactGroup(event);
    this.modalService
      .open(content, { size: 'lg', centered: true, windowClass: 'campaign-overview-modal' });
  }

  cloneCampaign(element: any) {
    if (!element || this.cloningId) {
      return;
    }
    this.cloningId = element.id;
    const campaignType = element.campaign_type || this.active;
    const payload: any = {
      campaign_name: `${element.campaign_name} Copy`,
      campaign_type: campaignType,
      template_id: element.template_id,
      subject: element.subject || null,
      client_id: this.localStorage.getClientId(),
      contact_group_id: element.contact_group_id,
      is_schedule: false,
      schedule_date: null,
      schedule_time: null,
      schedule_timezone: null,
      status: 'Pending',
      segment: element.segment || null,
      response_type: element.response_type || null,
    };
    if (String(campaignType).toLowerCase() === 'email') {
      payload.from_email = element.from_email || null;
      payload.cc_email = element.cc_email || null;
    }
    if (!this.isAdmin) {
      payload.user_id = this.localStorage.getUserId();
    }
    this.api.createCampaign(payload).subscribe({
      next: () => {
        this.cloningId = null;
        this.tracker.track('Create', 'Broadcast Campaign', `Cloned completed campaign ${element.campaign_name} as Pending`);
        this.toast.success('Campaign cloned as Pending');
        this.fetchCampaigns();
      },
      error: () => {
        this.cloningId = null;
        this.toast.error('Failed to clone campaign');
      }
    });
  }

  delete(content: any, event: any) {

  }

  handleGetWhatsappTemplateById(id: any) {

    this.isFetchingTemplates = true;
    const payload = {
      "client_id": this.localStorage.getClientId(),
      "template_id": id
    }
    this.api.getTemplateById(payload).subscribe(
      (res: any) => {
        this.whatsappPreviewTemplate = res;
        console.log("whatsapptemplate",this.whatsappPreviewTemplate)
        this.isFetchingTemplates = false
      },
      (error: any) => {
        this.isFetchingTemplates = false
        console.error('Error creating campaign', error);
      }
    );
  }

  handleGetEmailTemplateById(id: any) {
    this.isFetchingTemplates = true;
    const payload = {
      "client_id": this.localStorage.getClientId(),
      "template_id": id
    }
    this.api.getEmailTemplateById(payload).subscribe(
      (res: any) => {
        console.log("emailtemplate",res)
        this.processedData =  this.sanitizer.bypassSecurityTrustHtml(res.template_body); 
        this.attachments = res.attachments;
        this.isFetchingTemplates = false
      },
      (error: any) => {
        this.isFetchingTemplates = false
        console.error('Error creating campaign', error);

      }

    );
  }

  get noEligibleRecipients(): boolean {
    if (this.active !== 'whatsapp' && this.active !== 'email') {
      return false;
    }
    if (this.totalContactsInGroup === null || this.skipCampaignCount === null) {
      return false;
    }
    return this.skipCampaignCount >= this.totalContactsInGroup;
  }

  run(content: any, event: any) {
    this.campaign = event;
    this.loadRunAudienceCounts(event);

    if(this.active === 'whatsapp') {
      this.handleGetWhatsappTemplateById(event.template_id);
    }else if(this.active === 'email') {
      this.handleGetEmailTemplateById(event.template_id);
    }
    
    this.modalService
      .open(content, { size: 'md', centered: true })

  }

  private loadRunAudienceCounts(campaign: any): void {
    this.totalContactsInGroup = null;
    this.skipCampaignCount = null;
    this.isLoadingAudienceCount = false;

    if ((this.active !== 'whatsapp' && this.active !== 'email') || !campaign?.contact_group_id) {
      return;
    }
    if (this.active === 'email' && !campaign?.from_email) {
      return;
    }

    this.isLoadingAudienceCount = true;
    let pending = 2;
    const finish = () => {
      pending -= 1;
      if (pending <= 0) {
        this.isLoadingAudienceCount = false;
      }
    };

    this.contactGroupService.getAllContactGroupList({
      where: {
        client_id: this.localStorage.getClientId(),
        contact_group_id: campaign.contact_group_id,
      },
      filter: null,
      page: 0,
      limit: 10,
      order: {
        col: '"contact_group_list"."updatedAt"',
        dir: 'DESC',
      },
    }).subscribe({
      next: (res: any) => {
        this.totalContactsInGroup = res && res.count !== undefined ? Number(res.count) : 0;
        finish();
      },
      error: () => {
        this.totalContactsInGroup = null;
        finish();
      },
    });

    this.contactGroupService.getCampaignSkipCount({
      client_id: this.localStorage.getClientId(),
      contact_group_id: Number(campaign.contact_group_id),
      broadcast_type: this.active,
      sender_email: campaign.from_email || '',
    }).subscribe({
      next: (res: any) => {
        this.skipCampaignCount = Number(res?.count ?? 0);
        finish();
      },
      error: () => {
        this.skipCampaignCount = null;
        finish();
      },
    });
  }

  connectCampaign() {
    this.modalService.dismissAll();
    if(this.active=='whatsapp') {
      this.router.navigate(['/main/client-settings','whatsapp']);
    }else if(this.active=='email') {
      this.router.navigate(['/main/client-settings','notification']);
    }
  }
  runCampaign() {
    try {
      // Validate required fields
      if (!this.campaign.contact_group_id) {
        this.toast.error('Please select a contact group', 'Validation Error');
        return;
      }

      if (this.active !== 'call' && !this.campaign.template_id) {
        this.toast.error('Please select a template', 'Validation Error');
        return;
      }

      if (this.noEligibleRecipients) {
        this.toast.error(
          'No contacts will receive this campaign. Every contact in this group will be skipped today.',
          'Cannot launch'
        );
        return;
      }

      this.btnLoading = true;
      this.launchState = 'launching';

      let callObservable: any;

      if (this.active === 'call') {
        callObservable = this.voiceCampaignService.runTelephonyCampaign(this.campaign.id);
      } else {
        const payload = {
          broadcastType: this.active,
          client_id: this.localStorage.getClientId(),
          contact_group_id: this.campaign.contact_group_id,
          template_id: this.campaign.template_id,
          subject: this.active === 'email' ? this.campaign?.subject : null,
          campaign_id: this.campaign?.id,
          is_schedule: this.campaign.is_schedule,
        };
        console.log('Run campaign payload:', payload);
        callObservable = this.api.runCampaign(payload);
      }

      callObservable.subscribe({
        next: (res: any) => {
          const desc = `Campaign run for campaign ID: ${this.campaign?.id}, campaign name: ${this.campaign?.campaign_name} and campaign type: ${this.active}`;
          this.tracker.track('Run', 'Broadcast Campaign', desc);
          this.btnLoading = false;
          this.launchState = 'success';
          // Auto-close after showing success for 2.5 s
          setTimeout(() => {
            this.launchState = 'idle';
            this.modalService.dismissAll();
            if (this.active === 'call' && this.whatsappVoiceCampaignComponent) {
              this.whatsappVoiceCampaignComponent.loadCampaigns();
            } else {
              this.reload();
            }
          }, 2500);
        },
        error: (error: any) => {
          console.error('Error running campaign:', error);
          this.btnLoading = false;

          // Extract error message from various possible structures
          let errorMessage = 'Failed to run campaign. Please try again.';
          if (error?.error) {
            if (typeof error.error === 'string') {
              errorMessage = error.error;
            } else if (error.error.message) {
              errorMessage = error.error.message;
            } else if (error.error.error) {
              errorMessage = error.error.error;
            }
          } else if (error?.message) {
            errorMessage = error.message;
          }

          this.launchErrorMessage = errorMessage;
          this.launchState = 'failed';
        }
      });
    } catch (error: any) {
      console.error('Unexpected error running campaign:', error);
      this.btnLoading = false;
      this.launchErrorMessage = 'An unexpected error occurred. Please try again.';
      this.launchState = 'failed';
    }
  }

  resetLaunchState() {
    this.launchState = 'idle';
    this.launchErrorMessage = '';
    this.btnLoading = false;
    this.modalService.dismissAll();
  }

  deleteCampaign() {
    try {
      // Validate campaign ID
      if (!this.campaign?.id) {
        this.toast.error('Invalid campaign. Please try again.', 'Validation Error');
        return;
      }

      this.btnLoading = true;
      console.log('Deleting campaign:', this.campaign);

      const payload = {
        id: this.campaign.id
      };

      this.api.deleteCampaign(payload).subscribe({
        next: (res: any) => {
          const desc = `Broadcast campaign deleted with ID: ${payload.id}, name: ${this.campaign.campaign_name} and type: ${this.active}`;
          this.tracker.track('Delete', 'Broadcast Campaign', desc);
          this.handleUpdateData('delete');
        },
        error: (error: any) => {
          console.error('Error deleting campaign:', error);
          this.btnLoading = false;
          
          // Extract error message from various possible structures
          let errorMessage = 'Failed to delete campaign. Please try again.';
          
          if (error?.error) {
            if (typeof error.error === 'string') {
              errorMessage = error.error;
            } else if (error.error.message) {
              errorMessage = error.error.message;
            } else if (error.error.error) {
              errorMessage = error.error.error;
            }
          } else if (error?.message) {
            errorMessage = error.message;
          }
          
          this.toast.error(errorMessage, 'Delete Error');
        }
      });
    } catch (error: any) {
      console.error('Unexpected error deleting campaign:', error);
      this.btnLoading = false;
      this.toast.error(
        'An unexpected error occurred while deleting. Please try again.',
        'Error'
      );
    }
  }

  // Open test email modal
  openTestEmailModal(modal: any) {
    this.modalService.open(modal, { size: 'md', centered: true });
  }

  // Directly open test email modal from card list (email campaigns only)
  directTestCampaign(testEmailModalRef: any, element: any) {
    this.campaign = element;
    this.testEmail = '';
    this.modalService.open(testEmailModalRef, { size: 'md', centered: true });
  }

  // Send test email
  sendTestEmail(modal: any) {
    try {
      // Validate test email input
      if (!this.testEmail) {
        this.toast.error('Please enter at least one email address', 'Validation Error');
        return;
      }

      // Split by comma and trim whitespace
      const emailArray = this.testEmail
        .split(',')
        .map(email => email.trim())
        .filter(email => email.length > 0);

      if (emailArray.length === 0) {
        this.toast.error('Please enter valid email addresses', 'Validation Error');
        return;
      }

      // Validate each email format
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const invalidEmails = emailArray.filter(email => !emailRegex.test(email));

      if (invalidEmails.length > 0) {
        this.toast.error(
          `Invalid email format: ${invalidEmails.join(', ')}`,
          'Validation Error'
        );
        return;
      }

      // Validate campaign data
      if (!this.campaign?.id || !this.campaign?.template_id) {
        this.toast.error('Invalid campaign data. Please try again.', 'Validation Error');
        return;
      }

      this.testEmailLoading = true;

      const payload = {
        client_id: this.localStorage.getClientId(),
        contact_group_id: this.campaign.contact_group_id,
        campaign_id: this.campaign.id,
        template_id: this.campaign.template_id,
        test_emails: emailArray
      };

      console.log('Test email payload:', payload);

      this.api.testCampaignEmail(payload).subscribe({
        next: (res: any) => {
          this.testEmailLoading = false;
          const emailCount = emailArray.length;
          const emailList = emailArray.length > 3 
            ? `${emailArray.slice(0, 3).join(', ')}... (${emailCount} total)`
            : emailArray.join(', ');
          
          this.toast.success(
            `Test email sent successfully to ${emailList}`,
            'Success'
          );
          
          this.tracker.track(
            'Test Email', 
            'Broadcast Campaign', 
            `Test email sent for campaign: ${this.campaign?.campaign_name} to ${emailCount} recipient(s): ${emailArray.join(', ')}`
          );
          
          modal.dismiss('Cross click');
          this.testEmail = ''; // Reset
        },
        error: (error: any) => {
          this.testEmailLoading = false;
          console.error('Error sending test email:', error);
          
          // Extract error message from various possible structures
          let errorMessage = 'Failed to send test email. Please check your email configuration and try again.';
          
          if (error?.error) {
            if (typeof error.error === 'string') {
              errorMessage = error.error;
            } else if (error.error.message) {
              errorMessage = error.error.message;
            } else if (error.error.error) {
              errorMessage = error.error.error;
            }
          } else if (error?.message) {
            errorMessage = error.message;
          }
          
          this.toast.error(errorMessage, 'Test Email Error');
        }
      });
    } catch (error: any) {
      console.error('Unexpected error sending test email:', error);
      this.testEmailLoading = false;
      this.toast.error(
        'An unexpected error occurred while sending test email. Please try again.',
        'Error'
      );
    }
  }


  // Directly open test WhatsApp modal from card list (WhatsApp campaigns only)
  directTestWhatsappCampaign(testWhatsappModalRef: any, element: any) {
    this.campaign = element;
    this.testPhone = '';
    this.modalService.open(testWhatsappModalRef, { size: 'md', centered: true });
  }

  // Send test WhatsApp message
  sendTestWhatsapp(modal: any) {
    try {
      // Validate test phone input
      if (!this.testPhone) {
        this.toast.error('Please enter at least one phone number', 'Validation Error');
        return;
      }

      // Split by comma and trim whitespace
      const phoneArray = this.testPhone
        .split(',')
        .map(phone => phone.trim())
        .filter(phone => phone.length > 0);

      if (phoneArray.length === 0) {
        this.toast.error('Please enter valid phone numbers', 'Validation Error');
        return;
      }

      // Validate each phone format
      const invalidPhones = phoneArray.filter(phone => phone.length < 5);
      if (invalidPhones.length > 0) {
        this.toast.error(
          `Invalid phone number format: ${invalidPhones.join(', ')}. Include country code (e.g. +91).`,
          'Validation Error'
        );
        return;
      }

      // Validate campaign data
      if (!this.campaign?.id || !this.campaign?.template_id) {
        this.toast.error('Invalid campaign data. Please try again.', 'Validation Error');
        return;
      }

      this.testPhoneLoading = true;

      const payload = {
        client_id: this.localStorage.getClientId(),
        contact_group_id: this.campaign.contact_group_id,
        campaign_id: this.campaign.id,
        template_id: this.campaign.template_id,
        test_phones: phoneArray
      };

      console.log('Test WhatsApp payload:', payload);

      this.api.testCampaignWhatsapp(payload).subscribe({
        next: (res: any) => {
          this.testPhoneLoading = false;
          const phoneCount = phoneArray.length;
          const phoneList = phoneArray.length > 3 
            ? `${phoneArray.slice(0, 3).join(', ')}... (${phoneCount} total)`
            : phoneArray.join(', ');
          
          this.toast.success(
            `Test WhatsApp sent successfully to ${phoneList}`,
            'Success'
          );
          
          this.tracker.track(
            'Test WhatsApp', 
            'Broadcast Campaign', 
            `Test WhatsApp sent for campaign: ${this.campaign?.campaign_name} to ${phoneCount} recipient(s): ${phoneArray.join(', ')}`
          );
          
          modal.dismiss('Cross click');
          this.testPhone = ''; // Reset
        },
        error: (error: any) => {
          this.testPhoneLoading = false;
          console.error('Error sending test WhatsApp:', error);
          
          let errorMessage = 'Failed to send test WhatsApp message. Please check your config and try again.';
          if (error?.error) {
            if (typeof error.error === 'string') {
              errorMessage = error.error;
            } else if (error.error.message) {
              errorMessage = error.error.message;
            } else if (error.error.error) {
              errorMessage = error.error.error;
            }
          } else if (error?.message) {
            errorMessage = error.message;
          }
          
          this.toast.error(errorMessage, 'Test WhatsApp Error');
        }
      });
    } catch (error: any) {
      console.error('Unexpected error sending test WhatsApp:', error);
      this.testPhoneLoading = false;
      this.toast.error(
        'An unexpected error occurred while sending test WhatsApp. Please try again.',
        'Error'
      );
    }
  }

}

